import React from "react";
import styled from "styled-components";
import { Icon } from "components/common";
import styles from "./FieldTypeIcon.css";
const iconName = (type) => {
  switch (type) {
    case "string":
      return "text_fields";
    case "boolean":
      return "toggle_on";
    case "byte":
    case "double":
    case "float":
    case "int":
    case "long":
    case "short":
      return "show_chart";
    case "date":
      return "event";
    case "ip":
      return "lan";
    case "node":
      return "network_node";
    case "streams":
      return "fork_right";
    case "input":
      return "cell_tower";
    case "event-definition-id":
      return "edit_document";
    case "associated-assets":
      return "quick_reference";
    case "priority":
      return "emergency_home";
    default:
      return "help";
  }
};
const IconWrapper = styled.div`
  display: inline-flex;
  min-width: 20px;
  justify-content: center;
  align-items: center;
  vertical-align: -2px;
`;
const FieldTypeIcon = ({ type, monospace = true }) => {
  const icon = /* @__PURE__ */ React.createElement(Icon, { name: iconName(type.type), className: styles.fieldTypeIcon });
  return monospace ? /* @__PURE__ */ React.createElement(IconWrapper, null, icon) : icon;
};
export default FieldTypeIcon;
